<div dwRow>
    <div dwCol="12">
        <label class="label">Permit Type</label>
        <dw-multi-select-lookup [lookupId]="LookupId" [(ngModel)]="itemIds" mapToArray="true"
            (ngModelChange)="valuesChanged($event)"></dw-multi-select-lookup>
    </div>
</div>